
import database from '@react-native-firebase/database'
import messaging, { FirebaseMessagingTypes } from "@react-native-firebase/messaging"
import clientStorage from "core/clientStorage"
import loadDynamicEnv from "core/dynamicEnv"
import navhelper from "core/navhelper"
import { store } from "core/singleFileReduxManager"
import jwtDecode from "jwt-decode"
import { useEffect, useState } from "react"
import { Platform, View } from "react-native"
import types from "res/refGlobalTypes"
import { initClient } from "src/cloud"
import { Logout, Session, isUserProfileExist, makeDBPath } from "src/commons"
import BottomBar from "src/components/BottomBar"
import SafeAreaInsets from "src/components/SafeAreaInsets"
import ReduxStore, { ReduxUser, updateStore } from "src/models/ReduxStore"
import packageJson from "../../../package.json"
import NewVersionScreen from "./NewVersionScreen"
import ConsumerTabs from "./consumer/tabs/ConsumerTabs"
import ProviderTabs from "./provider/ProTabs/ProviderTabs"
import { getLocalStorageItem } from 'core/helpers'

export default function SplashScreen() {

  const [ shouldDisplayNewVersionScreen, setShouldDisplayNewVersionScreen ] = useState<boolean>(false);
  const [ isUpdateCompulsory, setIsUpdateCompulsory ] = useState<boolean>(false);

  const shouldUpdateVersion = () => {
    if(Platform.OS === 'web')
      return false;
    const configs = Session.configs || {latest_version:"1.0.0.0",force_update:false}
    
    const latestVersion = configs.latest_version;
    const forceUpdate = configs.force_update;

    const localAppVersion = packageJson.version;

    const isLatestVersionInstalled = Number( localAppVersion.replace(/\./g,"") ) >= Number(latestVersion.replace(/\./g,""))
    const isUpdateCompulsory = !isLatestVersionInstalled && forceUpdate;
    setIsUpdateCompulsory(isUpdateCompulsory);

    if(isUpdateCompulsory || !isLatestVersionInstalled) {
      setShouldDisplayNewVersionScreen(true);
      return true;
    }

    return false;
  }


   const redirectLoggedInUser = async (user) => {
    const decodedToken = jwtDecode(user.accessToken);

    if (decodedToken && decodedToken.admin) {
        navhelper.setRoot('AdminHomeScreen');
    } else if (decodedToken && !decodedToken.admin) {
        const profileExists = await isUserProfileExist(user);
        if (profileExists) {
            navhelper.setRoot('HomeScreen');
        } else {
            navhelper.setRoot('UserProfileScreen');
        }
    }
}
const isLoggedInUser=()=>{
 
    const loggedinUser = getLocalStorageItem("loggedinUser");
    if(loggedinUser && loggedinUser.stsTokenManager?.accessToken){
      loggedinUser.accessToken = loggedinUser.stsTokenManager?.accessToken;
      redirectLoggedInUser(loggedinUser);
    }else{
      navhelper.setRoot("LoginScreen")
    }
  

}
  const updateMainScreen = () => {
    setShouldDisplayNewVersionScreen(false);
    let user:ReduxUser = clientStorage.getItem("user")
    let provider:types.IProvider = clientStorage.getItem("provider")
    // console.log("User>>",user)
    updateStore({ user, provider })
    let IsAdmin=user?.token ? (jwtDecode(user.token)  as types.ITokenConent).isAdmin:false
    const IS_AUTHORIZED =(!!user && !!user?.full_name) || (!!provider?.email && !!user?.token ) || IsAdmin
    const params: any = Platform.OS != "web" ? {} : new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop as string),
    });

    if (params.dest) {
      navhelper.setRoot(params.dest)
    } else {
      if (!IS_AUTHORIZED) {
        isLoggedInUser()
      }
      else {
        if (IsAdmin){
          navhelper.setRoot("AdminHomeScreen")
        }
        else if (provider?.email){
          if (provider?.status=='profile_completed' || provider?.status=='active')
          navhelper.setRoot(ProviderTabs)
          else
          navhelper.setRoot("LoginScreen")
        }
        else{
          navhelper.setRoot(ConsumerTabs)
        }
      }
    }
  }

  useEffect(()=>{
    
    clientStorage.loadCache().then(() => 
    Promise.all([
    //   AsyncStorage.clear(),
        loadDynamicEnv(()=>initClient({
          logoutAction:Logout,
          getToken:()=>{
            return (store.getState() as ReduxStore).user?.token || ""
          }
        
        })).catch(e=>{
          throw e
        }),
      
        SafeAreaInsets.init(),
      
      ])
      .then(()=>{

        Session.configs=  clientStorage.getItem("serverConfigs")
        database().ref(makeDBPath("configs")).once('value').then(sp=>{
          Session.configs=sp.val()
          clientStorage.saveItem("serverConfigs",sp.val())
        })

        if(shouldUpdateVersion()) {
          return;
        }
          
        updateMainScreen();
      })
   )
  },[])
  
    return (
        <View  style={{ width: "100vw", height: "100vh", alignItems: "center",justifyContent:'center',flexDirection:'column'}}>
            <div style={{width:'100%',textAlign:'center',fontSize:36,fontWeight:'700' }}>Staff Docker</div>
            <NewVersionScreen visible={shouldDisplayNewVersionScreen} isUpdateCompulsory={isUpdateCompulsory} closeModal={() => updateMainScreen()} />
        </View>
    )
}
const handler=(msg:FirebaseMessagingTypes.RemoteMessage,isBack?:boolean)=>{

  console.log(isBack)
  if (msg.data?.isMsg){
   !Session.isChatActive && BottomBar.setIndicator(1)
  }
}
messaging().onMessage(handler)
messaging().setBackgroundMessageHandler( async (e)=>handler(e,true))